<template>
  <div class="cookie-page">
<h2>Cookie利用について</h2>
<dl>
<dd>当社では以下に記載するサービス（以下、「本サービス」といいます）において、利便性の向上や、利用者により有益と思われる広告を配信するために、クッキー（Cookie）を使用いたします。当社がクッキーにより取得する情報は、ブラウザ情報やブラウザを通じて利用者を識別する為の情報、ウェブサイトの閲覧情報、広告クリック履歴等（以下、「行動履歴情報」といいます。）であり、特定の個人を識別する情報は含まれておりません。なお、ブラウザの設定によりクッキーの機能を停止することは可能ですが、その場合、本サービスの一部をご利用できなくなることがございますのでご注意ください。<br><br> ・「占いフェス」【WEBサイト】<br> ・「超運ランキング」【WEBサイト】（uranaitv.jp/choun_ranking/）<br>・「占いTV」【WEBサイト】</dd>
<dt>ターゲティング広告について</dt>
<dd>当社は、本サービスを介したクッキーにより得られる行動履歴情報と、本サービス利用に伴い利用者にご提供いただく情報のうち性別や年齢等の利用者の属性に関する情報（これらの情報はいずれも個人を識別できない情報です）とを分析し、ターゲティング広告向けクッキー情報として自ら利用することや広告配信事業者等の第三者へ提供することがあります。尚、この場合に第三者に提供される情報はブラウザを判別するためのクッキー情報であり、個々の行動履歴そのものや特定の個人を識別できる情報は含まれません。</dd>
<dd>また、本サービスでは他の企業が配信を行うターゲティング広告を画面上に掲載することがあります。これらの企業は広告配信目的においてクッキーにより利用者の行動履歴情報を蓄積することがあり、これらの行動履歴情報はその企業のプライバシーポリシーに従って取り扱われます。</dd>
<dd>これらのターゲティング広告の配信を停止したい場合や行動履歴情報を削除したい場合は、以下の該当企業のサイトよりお手続きください。なお、この手続き後も引き続きターゲティングをしない広告は表示されます。また、手続き後にブラウザの設定においてクッキーを無効化した場合、ブラウザを変更した場合、新しいPCへ変更等をされた場合には再度この手続きが必要となりますのでご了承ください。</dd>
<dd>
・<a href="https://www.facebook.com/help/568137493302217/list" target="_blank">Facebook</a><br>
・<a href="https://help.twitter.com/ja/rules-and-policies/twitter-cookies" target="_blank">Twitter</a><br>
・<a href="https://support.google.com/ads/answer/1660762?visit_id=637092204982107449-4253286804&amp;rd=1" target="_blank">Google</a><br>
・<a href="https://tools.google.com/dlpage/gaoptout?hl=ja" target="_blank">Google Analytics</a><br>
・<a href="https://btoptout.yahoo.co.jp/optout/index.html" target="_blank">Yahoo! JAPAN</a>
</dd>
<dd>尚、本サービスが利用者よりご提供いただく個人情報は本サービスの<a href="/privacy">プライバシーポリシー</a>に基づき管理いたします（個人情報管理責任者より委任された、取締役が管理いたします）。その取扱の詳細については本サービスの<a href="/terms">利用規約</a>及び<a href="/privacy">プライバシーポリシー</a>をご確認ください。</dd>
</dl>
<p class="note">
2019年11月21日 制定<br>
2020年11月30日 改定<br>
2023年1月6日 改定
</p>
  </div>
</template>

<script>
export default {
  name: "CookiePage",
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.cookie-page {
  color: $col_base_black;
  font-size: 13px;
  line-height: 1.7;
  padding: 1px 4px 30px;
  h2 {
    font-weight: bold;
    font-size: 21px;
    text-align: center;
    margin: 45px 0 30px;
  }
  dl {
    padding: 0;
    margin: 0 0 1em;
    > dt {
      font-weight: bold;
      font-size: 13px;
      margin: 1.6em 0 1em;
    }
    > dd {
      margin: 0 0 1em;
    }
  }
  a {
    color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Help/Cookie.vue